import React from 'react';

const Analytics = () => <div>Analytics Page</div>;

export default Analytics; 